import React from 'react';
import { Divider as AntDivider, ConfigProvider } from 'antd';
import type { DividerProps as AntDividerProps } from 'antd';
import { cn } from '@/lib/utils';
import { colors } from '../../theme/colors';

export type DividerOrientation = 'left' | 'center' | 'right';
export type DividerType = 'horizontal' | 'vertical';
export interface DividerProps extends Omit<AntDividerProps, 'type' | 'orientation'> {
  type?: DividerType;
  orientation?: DividerOrientation;
  children?: React.ReactNode;
  dashed?: boolean;
  plain?: boolean;
  className?: string;
  marginTop?: number;
  marginBottom?: number;
}

export const Divider: React.FC<DividerProps> = ({
  type = 'horizontal',
  orientation = 'center',
  children,
  dashed = false,
  plain = true,
  className = '',
  marginTop = 16,
  marginBottom = 16,
  style,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorSplit: colors.surfaceSubtle,
          colorText: colors.textDefault,
        },
        components: {
          Divider: {
            textPaddingInline: 24,
            orientationMargin: 0,
          },
        },
      }}
    >
      <AntDivider
        type={type}
        orientation={orientation}
        orientationMargin={children ? 24 : undefined}
        dashed={dashed}
        plain={plain}
        className={cn(className)}
        style={{ marginTop, marginBottom, ...style }}
        {...props}
      >
        {children && (
          <span
            className="text-sm font-medium"
            style={{ color: colors.textDefault }}
          >
            {children}
          </span>
        )}
      </AntDivider>
    </ConfigProvider>
  );
};

export const OrDivider: React.FC<Omit<DividerProps, 'children'> & { text?: string }> = ({
  text = 'OR',
  ...props
}) => <Divider {...props}>{text}</Divider>;

export default Divider;
